// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"56f11bbc","299":"aabd848f","453":"756eb101","667":"dfecded6","910":"01b3fc59","977":"acdea2d4"}[chunkId] + ".chunk.js";
};